module.exports = __webpack_public_path__ + "img/forward-step.14eeb397.svg";